'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EmbedButton = undefined;

var _EmbedWindow = require('./EmbedWindow.js');

var EmbedButton = exports.EmbedButton = undefined;

exports.EmbedButton = EmbedButton = function EmbedButton(c) {
    var i18n = c.i18nManager.get();

    return Ext.create('Ext.button.Button', {
        text: i18n.embed,
        disabled: true,
        menu: {},
        handler: function handler(b) {
            (0, _EmbedWindow.EmbedWindow)(c).show();
        }
    });
};
//# sourceMappingURL=EmbedButton.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/EmbedButton.js
 ** module id = 160
 ** module chunks = 0 1
 **/